module.exports = __webpack_public_path__ + "static/media/Bubbly_ios_1_preview.16697f1d.jpg";